import React from "react";
import { Link } from "react-router-dom";
import "./ProductGrid.css";

function ProductGrid() {
  const products = [
    {
      id: 1,
      name: "Separador Dedos Pie de Silicona",
      image: "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692447/1_separador.jpg",
      description:
        "Con protector de juanetes. Almohadillas de gel que alivian el dolor metatarsiano, reducen la fricción y mejoran la circulación. Apto para cualquier calzado.",
    },
    {
      id: 2,
      name: "Faja Lumbar con Soporte de Aluminio",
      image: "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692426/1_faja.jpg",
      description:
        "Hombre y Mujer. Doble ajuste y presión abdominal con dos placas de aluminio. Alivia la ciática y el dolor de espalda manteniendo una postura correcta.",
    },
    {
      id: 3,
      name: "Codera Epicondilitis",
      image: "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692386/1_codera.jpg",
      description:
        "Pack de 2 unidades con almohadilla de silicona masajeadora y tejido 3D transpirable. Para tendinitis, codo de tenista, pádel y gym.",
    },
    {
      id: 4,
      name: "Tobillera para Esguince",
      image: "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693103/1_tobillera.jpg",
      description:
        "Hombre y Mujer. Placas de soporte PVC y bandas de compresión ajustable. Protección contra impactos, apta para llevar con zapatos.",
    },
  ];

  return (
    <div className="product-grid">
      <h2>Nuestros Productos</h2>
      <p className="product-grid-subtitle">
        Soluciones ortopédicas verificadas por miles de clientes en Amazon
      </p>
      <div className="grid">
        {products.map((product, index) => (
          <Link
            key={product.id}
            to={`/productos/${product.id}`}
            className={`product-link ${index % 2 === 0 ? "left-image" : "right-image"}`}
          >
            <div className="product-card">
              <div className="product-image">
                {product.image ? (
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-img"
                  />
                ) : (
                  <div className="placeholder-image">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                    </svg>
                    <span>Imagen próximamente</span>
                  </div>
                )}
              </div>
              <div className="product-info">
                <h3>{product.name}</h3>
                <p>{product.description}</p>

                <span className="product-cta">Ver detalles →</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default ProductGrid;
